/**
 * Object for coloring styled-components.
 * @type {{red: string, green: string, blue: string, white: string, black: string, purple: string}}
 */
export const colors = {
  purple: "#841983",
  pink: "#f696a9",
  lightpink: "#ffb7c5",
  green: "#91f160",
  lightgreen: "#d2f6c1",
  blue: "#4cdef5",
  white: "#ffffff",
  black: "#000000",
  grey: "#d3d3d3",
}
